/* eslint-disable react/prop-types */
/** @jsxImportSource @emotion/react */

import { useDispatch, useSelector } from 'react-redux';
import { memo } from 'react';
import { nike } from '@nike/nike-design-tokens';

import { RoleContentEnum } from '../../util/RoleContentEnum';
import { TranslatedCopy } from '../../intl/TranslatedCopy';
import Truncator from '../../components/Truncator';
import { formatDateTimestamp } from '../../util/date';
import { invitationsSelectors } from '../invitations/reducer';
import { usersActions } from './actions';

const UserTableRow = memo(({ user, userIsSelected, targetRef }) => {
  const dispatch = useDispatch();

  const invitationsActiveReview = useSelector(invitationsSelectors.activeReview);
  // eslint-disable-next-line no-nested-ternary
  const accountStatus = user.activeOnAccount ? (user?.isLockedOnAccount ? 'locked' : 'active') : 'deactivated';

  return (
    <tr
      css={{
        background: userIsSelected ? nike.podiumCdsColorBgAlwaysDark : nike.podiumCdsColorBgAlwaysLight,
        color: userIsSelected ? nike.podiumCdsColorTextPrimaryInverse : nike.podiumCdsColorTextPrimary,
        height: '50px',
        '&:not(:first-child)': {
          borderTop: `1px solid ${nike.podiumCdsColorBorderPrimary}`
        },
        '&:hover': {
          background: nike.podiumCdsColorGrey200,
          transition: 'background 0.5s'
        },
        '& > td': {
          padding: '14px'
        }
      }}
      onClick={() => {
        dispatch({ type: usersActions.selectUser.name, payload: user.id });
      }}
      ref={targetRef}
    >
      <td
        css={{
          display: invitationsActiveReview ? 'none' : 'table-cell',
          fontWeight: 500,
          width: '42%',
          '@media (min-width: 769px)': {
            display: 'table-cell',
            width: '27%'
          }
        }}
      >
        <Truncator value={`${user.firstName} ${user.lastName}`} />
      </td>
      <td
        css={{
          display: 'none',
          '@media (min-width: 769px)': {
            display: 'table-cell',
            width: '27%'
          }
        }}
      >
        <Truncator value={user.email} />
      </td>
      <td
        css={{
          width: '16%',
          '@media (min-width: 769px)': {
            width: '20%'
          }
        }}
      >
        <div
          css={{
            background: userIsSelected ? nike.podiumCdsColorWhite : nike.podiumCdsColorBlack,
            borderRadius: '5px',
            color: userIsSelected ? nike.podiumCdsColorBlack : nike.podiumCdsColorWhite,
            display: 'inline-block',
            marginRight: '12px',
            width: '20px',
            '&:before': {
              alignItems: 'center',
              content: RoleContentEnum[user.role],
              display: 'flex',
              fontSize: '12px',
              fontWeight: 'bold',
              height: '20px',
              justifyContent: 'center'
            }
          }}
        />
        <span
          css={{
            verticalAlign: 'middle',
            display: 'none',
            '@media (min-width: 769px)': {
              display: 'inline'
            }
          }}
        >
          <TranslatedCopy id={`userManagement.roles.${user.role.toLowerCase()}`} />
        </span>
      </td>
      <td
        css={{
          width: '42%',
          '@media (min-width: 769px)': {
            width: '13%'
          }
        }}
      >
        <TranslatedCopy id={`userManagement.status.${accountStatus}`} />
      </td>
      <td
        css={{
          display: 'none',
          '@media (min-width: 769px)': {
            display: 'table-cell',
            width: '13%'
          }
        }}
      >
        {formatDateTimestamp(user.lastLogin)}
      </td>
    </tr>
  );
});

export default UserTableRow;
